'use strict';
var $ = require('../internals/export');

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/web.url.to-json.js
// module id = ZzDe
// module chunks = 0